import TTELD from '../images/logo.svg';
import EVOELD from '../images/logo_evo.svg';
import ONTIMELOGS from '../images/logo_ontime.svg';
import ZIPPYELD from '../images/logo_zippy.svg';
import TTICON from '../images/logo.png';
import EVOICON from '../images/icon_evo.svg';
import ONTIMEICON from '../images/icon_ontime.svg';
import ZIPPYICON from '../images/icon_zippy.svg';
import FIVEELD from '../images/logo_five.svg';
import FIVEICON from '../images/icon_five.svg';
import ERAELD from '../images/logo_era.svg';
import ERAICON from '../images/icon_era.svg';
import LOGFLEET from '../images/logo_logfleet.svg';
import LOGFLEETICON from '../images/icon_logfleet.svg';
import RULERELD from '../images/logo_rulereld.svg';
import RULERELDICON from '../images/icon_rulereld.svg';
import FLEETVISION from '../images/logo_fleetvision.svg';
import FLEETVISIONICON from '../images/icon_fleetvision.svg';


import {
    useEffect,
    useState
} from 'react';

export const dashboards = {
    'localhost': {
        title: 'TT ELD',
        whichDash: 'tteld',
        dashboard: 'https://app.tteld.com',
        api: 'https://front-api.tteld.com/',
        logo: TTELD,
        icon: TTICON,
    },
    'tteld': {
        title: 'TT ELD',
        whichDash: 'tteld',
        dashboard: 'https://app.tteld.com',
        api: 'https://front-api.tteld.com/',
        logo: TTELD,
        icon: TTICON,
    },
    'evoeld': {
        title: 'EVO ELD',
        whichDash: 'evoeld',
        dashboard: 'https://dash.evoeld.com',
        api: 'https://front-api.evoeld.com/',
        logo: EVOELD,
        icon: EVOICON,
    },
    'ontime-logs': {
        title: 'ONTIME LOGS',
        whichDash: 'ontime-logs',
        dashboard: 'https://dash.ontime-logs.com',
        api: 'https://front-api.ontime-logs.com/',
        logo: ONTIMELOGS,
        icon: ONTIMEICON,
    },
    'zippyeld': {
        title: 'ZIPPY ELD',
        whichDash: 'zippyeld',
        dashboard: 'https://dash.zippyeld.com',
        api: 'https://front-api.zippyeld.com/',
        logo: ZIPPYELD,
        icon: ZIPPYICON,
    },
    'fiveeld': {
        title: 'FIVE ELD',
        whichDash: 'fiveeld',
        dashboard: 'https://dash.fiveeld.com',
        api: 'https://front-api.fiveeld.com/',
        logo: FIVEELD,
        icon: FIVEICON,
    },
    'eraeld': {
        title: 'ERA ELD',
        whichDash: 'eraeld',
        dashboard: 'https://dash.eraeld.com',
        api: 'https://front-api.eraeld.com/',
        logo: ERAELD,
        icon: ERAICON,
    },
    'logfleet': {
        title: 'LOGFLEET',
        whichDash: 'logfleet',
        dashboard: 'https://dash.logfleet.com',
        api: 'https://front-api.logfleet.com/',
        logo: LOGFLEET,
        icon: LOGFLEETICON,
    },
    'rulereld': {
        title: 'RULER ELD',
        whichDash: 'rulereld',
        dashboard: 'https://dash.rulereld.com',
        api: 'https://front-api.rulereld.com/',
        logo: RULERELD,
        icon: RULERELDICON,
    },
    'fleetvision': {
        title: 'FLEETVISION',
        whichDash: 'fleetvision',
        dashboard: 'https://dash.fleetvision.co',
        api: 'https://front-api.fleetvision.co/',
        logo: FLEETVISION,
        icon: FLEETVISIONICON,
    },
}
export const useWhichDashboard = () => {
    const hostname = useHostname();
    if (!hostname) {
        return dashboards['tteld'];
    }
    if (hostname.includes('tteld')) {
        return dashboards['tteld'];
    }
    if (hostname.includes('evoeld')) {
        return dashboards['evoeld'];
    }
    if (hostname.includes('ontime-logs') || hostname.includes('ontimeeld')) {
        return dashboards['ontime-logs'];
    }
    if (hostname.includes('zippyeld')) {
        return dashboards['zippyeld'];
    }
    if (hostname.includes('fiveeld')) {
        return dashboards['fiveeld'];
    }
    if (hostname.includes('eraeld')) {
        return dashboards['eraeld'];
    }
    if (hostname.includes('logfleet')) {
        return dashboards['logfleet'];
    }
    if (hostname.includes('rulereld')) {
        return dashboards['rulereld'];
    }
    if (hostname.includes('fleetvision')) {
        return dashboards['fleetvision'];
    }
    return dashboards['tteld'];
}

const useHostname = () => {
    const [hostname, setHostname] = useState(null);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setHostname(window.location.hostname);
        }
    }, []);

    return hostname;
};